import { SerializedStyles, css } from '@emotion/react';
import { createRoutingURI, getRootSlug } from '@scripts/utils/domain';
import { TeaserNavigationProps } from 'ech-components/src/components/TeaserNavigation';
import { mixins } from 'ech-components/src/core/styles/theme/default';
import { LinkVariant } from 'ech-components/src/primitives/Link/Link';
import { ImageInterface } from 'ech-components/src/types';

const navigationTeaserService = (data: {
  teasers: object[];
  variant?: LinkVariant;
  customGrid?: SerializedStyles;
  imageSizes?: ImageInterface['imageSizes'];
}) => {
  const { teasers, variant, imageSizes } = data;
  let { customGrid } = data;
  let sizes = imageSizes || {
    0: [480, 280],
    480: [390, 250],
    768: [508, 294],
    1024: [296, 186],
    1280: [272, 196],
    1440: [312, 194],
  };

  if (!customGrid && [1, 2, 3].includes(teasers.length)) {
    customGrid = css`
      ${mixins.MQ('large')} {
        grid-template-columns: repeat(3, 1fr);
      }
    `;

    sizes = {
      ...sizes,
      1024: [406, 264],
      1280: [370, 244],
      1440: [428, 275],
    };
  }

  const teaserNavigationProps: TeaserNavigationProps = teasers
    ? {
        items: teasers.map((item: any) => ({
          ...item,
          backgroundImage: {
            ...item.teaserImage,
            imageSizes: sizes,
          },
          href: createRoutingURI(getRootSlug(item, item.node_locale)),
        })),
        variant,
        customGrid,
      }
    : null;

  return teaserNavigationProps;
};

export default navigationTeaserService;
